/**
 * Puschies Größenrechner (blocks/p-size-calculator.liquid), 1:1 Logik aus Hyper custom_liquid_GROESSENRECHNER.
 * - setzt den Link „Unser Größenrechner“ in die Legende der Größen-Option des Variant-Pickers (auch nach Re-Render)
 * - füllt die Auswahl 9,5–15,0 cm, berechnet die Größe (größerer Fuß zählt) und markiert die Tabellenzeile
 * Texte kommen aus dem JSON-Block [data-p-size-config] (Sprachdateien), Maße = Hyper-Größentabelle.
 */

const TABLE = [
  { max: 10.0, size: '18', sole: 11.5, width: 5.5, age: ['6–10', 'months'] },
  { max: 11.0, size: '19/20', sole: 12.5, width: 5.8, age: ['10–15', 'months'] },
  { max: 12.0, size: '20/21', sole: 13.5, width: 6.1, age: ['15–18', 'months'] },
  { max: 13.0, size: '22/23', sole: 14.5, width: 6.4, age: ['1,5–2,5', 'years'] },
  { max: 14.0, size: '24/25', sole: 15.5, width: 6.7, age: ['2,5–3', 'years'] },
];

// Platzhalter {{ name }} (Sprachdatei) bzw. [name] (von Liquid schon interpolierte Texte, z. B. mit Link)
const fill = (template, values) =>
  String(template || '').replace(/\{\{\s*(\w+)\s*\}\}|\[(\w+)\]/g, (match, a, b) => values[a || b] ?? match);

function init(root) {
  if (root.dataset.pSizeInit) return;
  root.dataset.pSizeInit = '1';

  let config = {};
  try {
    config = JSON.parse(root.querySelector('[data-p-size-config]')?.textContent || '{}');
  } catch (error) {
    return;
  }

  const decimal = config.decimal || ',';
  const cm = (value) => `${value.toFixed(1).replace('.', decimal)} cm`;
  const ageText = ([range, unit]) => fill(config[unit] || '{{ range }}', { range: range.replace(/,/g, decimal) });

  const selectLeft = root.querySelector('[data-p-size-input="left"]');
  const selectRight = root.querySelector('[data-p-size-input="right"]');
  const button = root.querySelector('[data-p-size-calc-button]');
  const result = root.querySelector('[data-p-size-result]');
  const sizeEl = root.querySelector('[data-p-size-size]');
  const metaEl = root.querySelector('[data-p-size-meta]');
  const tbody = root.querySelector('[data-p-size-table] tbody');
  if (!selectLeft || !selectRight || !button || !result || !tbody) return;

  // Größentabelle
  tbody.innerHTML = TABLE.map(
    (row) =>
      `<tr data-size="${row.size}"><td>${row.size}</td><td>${fill(config.upTo, { value: cm(row.max) })}</td>` +
      `<td>${cm(row.sole)}</td><td>${cm(row.width)}</td><td>${ageText(row.age)}</td></tr>`
  ).join('');

  // Auswahl 9,5–15,0 cm in 0,1-Schritten
  for (let v = 9.5; v <= 15.0 + 1e-9; v += 0.1) {
    const value = Math.round(v * 10) / 10;
    selectLeft.appendChild(new Option(cm(value), String(value)));
    selectRight.appendChild(new Option(cm(value), String(value)));
  }

  const calc = () => {
    const left = parseFloat(selectLeft.value);
    const right = parseFloat(selectRight.value);
    const values = [left, right].filter((x) => !isNaN(x));
    if (!values.length) {
      result.classList.remove('is-visible');
      return;
    }
    const ref = Math.max(...values);
    const side = left === ref && right === ref ? config.both : left > right ? config.left : config.right;
    const match = TABLE.find((row) => ref <= row.max + 1e-9);

    result.classList.remove('is-oversize');
    tbody.querySelectorAll('tr.is-match').forEach((el) => el.classList.remove('is-match'));

    if (!match) {
      sizeEl.textContent = '—';
      metaEl.innerHTML = fill(config.oversize, { length: cm(ref), size: TABLE[TABLE.length - 1].size });
      result.classList.add('is-oversize');
    } else {
      sizeEl.textContent = fill(config.size, { size: match.size });
      const item = (label, value) => `<li><span class="p-size-calc__meta-label">${label}</span>${value}</li>`;
      metaEl.innerHTML =
        '<ul>' +
        item(config.basedOn, `${cm(ref)} (${side})`) +
        item(config.sole, cm(match.sole)) +
        item(config.width, cm(match.width)) +
        item(config.age, ageText(match.age)) +
        '</ul>';
      tbody.querySelector(`tr[data-size="${match.size}"]`)?.classList.add('is-match');
    }
    result.classList.add('is-visible');
  };

  button.addEventListener('click', calc);
  [selectLeft, selectRight].forEach((select) =>
    select.addEventListener('change', () => {
      if (selectLeft.value || selectRight.value) calc();
    })
  );

  // Link in der Größen-Legende
  const names = String(config.optionNames || 'größe,size')
    .toLowerCase()
    .split(',')
    .map((name) => name.trim())
    .filter(Boolean);
  const scope = root.closest('.shopify-section') || document;

  const injectTrigger = () => {
    scope.querySelectorAll('variant-picker fieldset legend').forEach((legend) => {
      if (legend.querySelector('.p-size-calc-trigger')) return;
      const nameEl = legend.querySelector('.p-option-name');
      const label = (nameEl ? nameEl.textContent : legend.firstChild?.textContent || '').toLowerCase();
      if (!names.some((name) => label.includes(name))) return;
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'p-size-calc-trigger';
      trigger.textContent = config.trigger;
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        root.showDialog();
      });
      legend.appendChild(trigger);
    });
  };

  injectTrigger();
  new MutationObserver(injectTrigger).observe(scope, { childList: true, subtree: true });
}

const boot = () => document.querySelectorAll('[data-p-size-calc]').forEach(init);

if (customElements.get('dialog-component')) boot();
else customElements.whenDefined('dialog-component').then(boot);
document.addEventListener('shopify:section:load', boot);
